import { colors } from "../../Styles";

export function Note({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <g transform="matrix(1.37756,0,0,1.99731,-11.3168,72.087)">
          <path d="M192.2,68.259L192.2,74.776C192.2,76.575 190.083,78.035 187.475,78.035L34.725,78.035C32.117,78.035 30,76.575 30,74.776L30,68.259C30,66.46 32.117,65 34.725,65L187.475,65C190.083,65 192.2,66.46 192.2,68.259Z"/>
      </g>
      <g transform="matrix(0.761036,0,0,1.99731,7.17893,-0.61797)">
          <path d="M192.2,68.259L192.2,74.776C192.2,76.575 188.368,78.035 183.648,78.035L38.552,78.035C33.832,78.035 30,76.575 30,74.776L30,68.259C30,66.46 33.832,65 38.552,65L183.648,65C188.368,65 192.2,66.46 192.2,68.259Z"/>
      </g>
      <g transform="matrix(1.0693,0,0,1.99731,-2.06891,-74.313)">
          <path d="M192.2,68.259L192.2,74.776C192.2,76.575 189.473,78.035 186.113,78.035L36.087,78.035C32.727,78.035 30,76.575 30,74.776L30,68.259C30,66.46 32.727,65 36.087,65L186.113,65C189.473,65 192.2,66.46 192.2,68.259Z"/>
      </g>
    </svg>
  );
}